import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { ProgramService } from '../program.service';

import { of } from "rxjs";


@Injectable()
export class ProgramsByTypeResolver implements Resolve<Observable<string>> {

    constructor(private programService: ProgramService) { }

    resolve(route: ActivatedRouteSnapshot) {
        var types = route.data['resolverProgramTypes'];
        return this.programService.getProgramsByType(types).catch(() => {
            return of('error');
        });
    }

}

